export default __webpack_public_path__ + "service-worker-b2fb40a.js";